import { departamentsTypes } from "../constantes/actionTypes"

const initialState = []

export const departaments = (state = initialState, action) => {
    switch (action.type) {
        case departamentsTypes.GET_ALL_DEPARTAMENTS_SUCCESS:
            return action.payload
        case departamentsTypes.NEW_DEPARTAMENT_SUCCESS:
            return [...state , action.payload]
        case departamentsTypes.UPDATE_DEPARTAMENT_SUCCESS:
            const updateDepartament = state.map(item => {
                if (item.id_TipoDepartamento === action.payload.id_TipoDepartamento)
                    return action.payload
                return item
            })
            return updateDepartament
        case departamentsTypes.DELETE_DEPARTAMENT_SUCCESS:
            return state.filter(item => item.id_TipoDepartamento !== action.payload.id_TipoDepartamento)
        case departamentsTypes.NEW_DEPARTAMENT_FAILURE:
        case departamentsTypes.UPDATE_DEPARTAMENT_FAILURE:
        case departamentsTypes.DELETE_DEPARTAMENT_FAILURE:
            return state
        case departamentsTypes.GET_ALL_DEPARTAMENTS_FAILURE:
            return initialState
        default:
            return state
    }
}